import { formatNumWithKMB, formatNumWithKMBAlt, formatWord } from 'utils/helperMethods';
import _ from 'lodash';

function calculateRowSpanForAttributeLevel(attributeNameData: any) {
    let count = 0;
    attributeNameData.attributeData.forEach((mechData: any, mechKey: any) => {
        count = count + mechData.mechanicsData.length;
    });
    return count;
}

// {
//
//     "color": {
//         "__typename": "Colors",
//         "R": 144,
//         "G": 219,
//         "B": 130
//     },
//     "tacticsColor": "#A0DBD8",
//     "mechanicsColor": "#FAFAFC",
//     "tactics": "TPR",
//     "name": "KIND BREAKFAST 4/6",
//     "mechanics": "5X"
// }

// {
//     "__typename": "PortfolioBubbleData",
//     "groupBy1": "KIND BREAKFAST",
//     "groupBy2": "KIND BREAKFAST 4/6",
//     "weeks": 66,
//     "kpisData": [
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "lift",
//             "kpiValue": 0.23339357015962656
//         },
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "roi",
//             "kpiValue": 1.8028528679028484
//         },
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "investments",
//             "kpiValue": 1448747.06
//         },
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "incremental_net_sales_per_week",
//             "kpiValue": 1875.4498259823959
//         },
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "incremental_profit_per_week",
//             "kpiValue": 1085.1174873231491
//         },
//         {
//             "__typename": "PortfolioKpis",
//             "kpiName": "incremental_retailer_profit_per_week",
//             "kpiValue": 232.1622906296335
//         }
//     ]
// }

export function bubbleChartDriverParser(data: any, group1: any) {
    let FormattedData = data.map((item: any) => {
        let tempObj: any = {};
        tempObj['name'] = item.groupBy1;
        tempObj['tactics'] = item.groupBy2 ? formatWord(item.groupBy2) : null;
        item.kpisData.forEach((kpi: any) => {
            tempObj[kpi.kpiName] = typeof kpi.kpiValue === 'number' ? _.round(kpi.kpiValue, 2) : kpi.kpiValue;
        });
        tempObj[`group1`] = formatWord(group1);
        return tempObj;
    });
    return FormattedData;
}
